import { BasketballGrade } from "../common/basketballGrades";

export enum Role {
  none = 0,
  scoretable = 1 << 0,
  referee = 1 << 1,
  supervisor = 1 << 2,
  refereeCoach = 1 << 3,
  administrative = 1 << 4,
  statistician = 1 << 5,
}

export namespace Role {
  export function getAllRoles() {
    return [
      Role.administrative,
      Role.refereeCoach,
      Role.supervisor,
      Role.referee,
      Role.scoretable,
      Role.statistician,
    ];
  }
  export function getValue(role) {
    return isNaN(role) ? Role[role] : role;
  }
  export function hasRole(role: Role, roleToCheck: Role) {
    // checks if the role has all the roles in roleToCheck
    return (role & roleToCheck) == roleToCheck;
  }
  export function addRole(role: Role, roleToAdd: Role) {
    return role | Role.getValue(roleToAdd);
  }
  export function hasRoles(role: Role, rolesToCheck: Role | Role[]) {
    if (Array.isArray(rolesToCheck))
      return rolesToCheck.every((r) => Role.hasRole(role, r));
    return Role.hasRole(role, rolesToCheck);
  }
  export function hasAnyRole(role: Role, rolesToCheck: Role | Role[]) {
    if (Array.isArray(rolesToCheck))
      return rolesToCheck.some((r) => Role.hasRole(role, r));
    return Role.hasRole(role, rolesToCheck);
  }
  export function everyRole(): Role {
    return Role.getAllRoles().reduce((prev, r) => prev | r, 0);
  }

  export function removeRole(role: Role, roleToRemove: Role) {
    return (role | Role.getValue(roleToRemove)) ^ Role.getValue(roleToRemove);
  }

  export function getRoleNames(role): string[] {
    return Role.getAllRoles()
      .filter((k) => Role.hasRole(role, k))
      .map((k) => Role.toString(k));
  }
  export function toString(role: Role) {
    switch (Role.getValue(role)) {
      case Role.scoretable:
        return "Scoretable";
      case Role.referee:
        return "Referee";
      case Role.supervisor:
        return "Supervisor";
      case Role.refereeCoach:
        return "Referee Coach";
      case Role.administrative:
        return "Administrative";
      case Role.statistician:
        return "Statistician";
      default:
        return "Unknown";
    }
  }

  export function toShortString(role: Role) {
    const roleStrings: [Role, string][] = [
      [Role.referee, "R"],
      [Role.scoretable, "S"],
      [Role.supervisor, "Sp"],
      [Role.refereeCoach, "Rc"],
      [Role.administrative, "A"],
      [Role.statistician, "Stat"],
    ];
    return roleStrings
      .filter((k) => Role.hasRole(role, k[0]))
      .map((k) => k[1])
      .join("+");
  }

  export function getRoleFrom(
    vbraNumber?: string,
    grade?: BasketballGrade,
    refereeCoachGrade?: string,
    statisticianGrade?: string,
  ): Role {
    let r = 0;
    if (vbraNumber || grade) {
      r |= Role.referee;
    }
    if (refereeCoachGrade) {
      r |= Role.refereeCoach;
    }
    if (statisticianGrade) {
      r |= Role.statistician;
    }
    return r;
  }
}
